import { dayOffsetToDate } from '../shared'
import { Directory, UiType } from '../../../lib/commons/appFunction'
import { demoUser } from '../tenants/tenant'
import {
  ProjectStatus,
  WbsItemCodeFormat,
} from '../../../domain/entity/ProjectEntity'

export const demoProject = {
  uuid: 'demo-project-uuid',
  lockVersion: 1,
  revision: 'demo-revision',
  children: [],
  code: 'demo',
  displayName: 'デモプロジェクト',
  officialName: 'デモプロジェクト',
  iconUrl: '',

  get scheduledDate() {
    return {
      startDate: dayOffsetToDate(-90),
      // WBSの計画（wbs-items.tsのDEMO_PLAN_END_DAY = 434）に合わせる。今日
      // （day 42）から約1年後にプロジェクトが完了する形。wbs-items.tsは
      // demoProjectを参照するため、循環参照を避けて定数は持たず直接指定する。
      // 工程を追加して計画が延びた場合はここも延ばす。
      endDate: dayOffsetToDate(434),
    }
  },
  get actualDate() {
    // ProjectDetail.actualDate.endDateはstring型のため、進行中プロジェクト
    // （終了日未定）を空文字列で表す。
    return { startDate: dayOffsetToDate(-90), endDate: '' }
  },
  mainEmail: 'demo-project@example.com',
  division: {
    uuid: 'demo-division-uuid',
    displayName: 'デモ事業部',
    officialName: 'デモ事業部',
  },
  businessClient: {
    uuid: 'demo-client-uuid',
    displayName: 'デモ株式会社',
    officialName: 'デモ株式会社',
  },
  projectManager: demoUser,
  assigned: true,
  status: ProjectStatus.INPROGRESS,
  wbsItemCodeFormat: WbsItemCodeFormat.RANDOM,
}

export const DEMO_WBS_ITEM_FUNCTION_UUID = 'demo-function-wbs-item'

// version-report.tsではなくここで定義する。version-report.ts → wbs-items.ts
// → members.ts → このファイル、と循環するため、あちらに置くと初期化順が
// 壊れる（REQUIREMENTS_PHASE_ITEMSがundefinedになる）。
export const DEMO_VERSION_REPORT_FUNCTION_UUID = 'demo-function-version-report'

// プログラムの管理画面はpageComponent HOCでラップされており、
// state.appFunction.functionsにexternalIdが無いと何も描画しない
// （他のデモ画面はprojectPrivate経由でこの判定を通らない）。そのため
// デモ専用のexternalIdを下の機能一覧に載せる。この一覧は画面遷移には
// 使われない（デモのSideMenuは静的実装）ので、載せても導線は増えない。
export const DEMO_PROGRAM_MANAGEMENT_FUNCTION_UUID =
  'demo-function-program-management'
export const DEMO_PROGRAM_MANAGEMENT_EXTERNAL_ID = 'mock.programManagement'

export const demoFunctionDirectory: Directory = {
  uuid: 'demo-directory-project',
  externalId: 'demo-directory-project',
  name: 'プロジェクト',
  displayOrder: 1,
  defaultOpen: true,
  directories: [],
  functions: [
    {
      uuid: 'demo-function-project-plan',
      externalId: 'projectPlan.new.edit',
      name: 'プロジェクト計画',
      hidden: false,
      uiType: UiType.Custom,
      displayOrder: 1,
      configurable: false,
    },
    // App.tsx builds every /tickets, /ticketLists route from this list
    // (functions.flatMap looking up view/pages/index.tsx's `components` map
    // by externalId) — without these two, ProjectPlanNew's addTicket flow
    // has nowhere to navigate to and the Tickets/TicketLists screens 404.
    {
      uuid: 'demo-function-tickets',
      externalId: 'ticket.list.edit',
      name: 'チケット一覧',
      hidden: false,
      uiType: UiType.Custom,
      displayOrder: 2,
      configurable: false,
    },
    {
      uuid: 'demo-function-ticket-lists',
      externalId: 'ticketLists.edit',
      name: 'チケット管理表一覧',
      hidden: false,
      uiType: UiType.Custom,
      displayOrder: 3,
      configurable: false,
    },
    // 進捗レポート画面。uuidはPageProps.uuid（ui_statesの
    // applicationFunctionUuid）として渡す値の定義元。
    {
      uuid: DEMO_VERSION_REPORT_FUNCTION_UUID,
      externalId: 'project.report.versionReport',
      name: '進捗レポート',
      hidden: false,
      uiType: UiType.Custom,
      displayOrder: 4,
      configurable: false,
    },
    // 画面遷移には使わないが、コメントの表示に必須。
    // getWbsItemFunctionUuid（lib/functions/wbsItem）がこのexternalIdで
    // appFunction.functionsを検索し、見つからないとディスカッションが開かない。
    {
      uuid: DEMO_WBS_ITEM_FUNCTION_UUID,
      externalId: 'wbsItem',
      name: 'WBSアイテム',
      hidden: true,
      uiType: UiType.Custom,
      displayOrder: 5,
      configurable: false,
    },
    {
      uuid: DEMO_PROGRAM_MANAGEMENT_FUNCTION_UUID,
      externalId: DEMO_PROGRAM_MANAGEMENT_EXTERNAL_ID,
      name: 'プログラムの管理',
      hidden: false,
      uiType: UiType.Custom,
      displayOrder: 6,
      configurable: false,
    },
  ],
}
